import {ValidationErrorsEnum} from '../enums/validation/validation-errors.enum';
import {ValidationErrors} from '@angular/forms';

const ERROR_KEY_MAP: Record<string, ValidationErrorsEnum> = {
  required: ValidationErrorsEnum.REQUIRED,
  minlength: ValidationErrorsEnum.MIN_LENGTH,
  maxlength: ValidationErrorsEnum.MAX_LENGTH,
  pattern: ValidationErrorsEnum.PATTERN,
  email: ValidationErrorsEnum.EMAIL,
  minDate: ValidationErrorsEnum.MIN_DATE,
  maxDate: ValidationErrorsEnum.MAX_DATE
};

const ERROR_PRIORITY: readonly (keyof typeof ERROR_KEY_MAP)[] = [
  'required',
  'minlength',
  'maxlength',
  'pattern',
  'email',
  'minDate',
  'maxDate'
];

export class ValidationErrorsDictionary {
  public static resolveValidationErrors(validationErrors: ValidationErrors | null | undefined): ValidationErrorsEnum | null {
    if (!validationErrors) return null;

    for (const key of ERROR_PRIORITY) {
      if (validationErrors[key]) {
        return ERROR_KEY_MAP[key];
      }
    }

    return ValidationErrorsEnum.UNKNOWN;
  }
}
